<template>
  <div class="better">
    <img class="better__bg-image1" src="@images/betterBgImage1.png" alt="image">
    <img class="better__bg-image2" src="@images/betterBgImage2.png" alt="image">
    <div class="container">
      <div class="better__wrapper">
        <div class="better__title">
          <p>{{ t('home.better.title') }}</p>
        </div>
        <div class="better__subtitle">
          <p>{{ t('home.better.subtitle1') }}</p>
          <p>{{ t('home.better.subtitle2') }}</p>
        </div>
        <div class="better__main">
          <div class="better__main-image">
            <img src="@images/betterImage.png" alt="image">
            <router-link :to="translations.i18nRoute({ name: 'store', params: { category: 'templates' } })" class="better__main-button">
              {{ t('buttons.getStarted') }}
              <svg viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4.5H20V3.5H0V4.5Z" fill="#2B3044"/>
              </svg>
            </router-link>
          </div>
          <div class="better__main-block">
            <div class="better__main-item better__main-item-blue">
              <div>
                <p>{{ t('home.better.item1') }}</p>
                <img src="@icons/betterIcon1.svg" alt="icon">
              </div>
            </div>
            <div class="better__main-item">
              <div>
                <p>{{ t('home.better.item2') }}</p>
                <img src="@icons/betterIcon2.svg" alt="icon">
              </div>
            </div>
            <div class="better__main-item">
              <div>
                <p>{{ t('home.better.item3') }}</p>
                <img src="@icons/betterIcon3.svg" alt="icon">
              </div>
            </div>
            <div class="better__main-item better__main-item-blue">
              <div>
                <p>{{ t('home.better.item4') }}</p>
                <img src="@icons/betterIcon4.svg" alt="icon">
              </div>
            </div>
            <svg width="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="56" cy="56" r="56" fill="#F2B5D4"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.better {
  padding-block: 100px;
  position: relative;

  &__bg {
    &-image1 {
      position: absolute;
      top: 0;
      left: 0;
    }

    &-image2 {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &__wrapper {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    border-radius: 17px;
    background-color: $white;
    box-shadow: 0 4px 13.5px 0 rgba(0, 0, 0, 0.15);
    width: fit-content;
    padding: 5px 30px;

    & p {
      text-align: center;
      font-family: Syne, sans-serif;
      font-size: 50px;
      font-weight: 700;
      background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &__subtitle {
    width: 100%;
    margin-top: 45px;
    color: #696969;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
  }

  &__main {
    width: 100%;
    margin-top: 115px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-image {
      position: relative;

      & img {
        width: 700px;
      }
    }

    &-button {
      position: absolute;
      cursor: pointer;
      left: 34px;
      bottom: 25px;
      padding: 5px 20px;
      border-radius: 12px 30px 30px 12px;
      border: 0.5px solid #2B3044;
      background-color: $white;
      box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.20);
      display: flex;
      align-items: center;
      gap: 20px;
      flex-shrink: 0;
      transition: 0.2s;

      color: #2B3044;
      text-align: center;
      font-size: 20px;
      font-weight: 500;

      &:hover {
        background-color: #cbcbcb;
      }

      & svg {
        width: 20px;
      }
    }

    &-block {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
      position: relative;

      & svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &-item {
      width: 240px;
      aspect-ratio: 1;
      border-radius: 23px;
      border: 2px solid #F2B5D4;
      background: linear-gradient(136deg, #F2B5D4 43.22%, #F7D6E0 99.47%);
      position: relative;
      z-index: 1;

      &:nth-child(2) {
        background: linear-gradient(225deg, #FFF 61.68%, #F7D6E0 116.77%);

        & p {
          color: #233251;
        }
      }
      &:nth-child(3) {
        border-radius: 23px;
        border: 2px solid #F2B5D4;
        background: linear-gradient(25deg, #FFF 61.68%, #F7D6E0 116.77%);

        & p {
          color: #233251;
        }
      }
      &:nth-child(4) {
        background: linear-gradient(315deg, #F2B5D4 43.14%, #F7D6E0 100%);

        & p {
          color: $white;
        }
      }

      &-blue {
        padding: 10px;

        & div {
          padding-inline: 10px !important;
          border-radius: 7px;
          border: 2px solid #FFF;
        }
      }

      & div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 5px;
        padding-inline: 21px;
        height: 100%;
      }

      & p {
        word-break: break-word;
        color: $white;
        font-family: Syne, sans-serif;
        font-size: 26px;
        font-weight: 700;
      }

      & img {
        align-self: flex-end;
      }
    }
  }
}

@media (max-width: 1680px) {
  .better {
    &__main {
      &-image {
        width: 600px;
        height: 498px;

        & img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 7px;
        }
      }
    }
  }
}

@media (max-width: 1250px) {
  .better {
    &__main {
      flex-direction: column;
      gap: 50px;

      &-block {
        column-gap: 125px;
      }
    }
  }
}

@media (max-width: 900px) {
  .better {
    &__title {
      & img {
        display: none;
      }
    }

    &__subtitle {
      width: 100%;
    }
  }
}

@media (max-width: 750px) {
  .better {
    &__main {
      &-image {
        width: 100%;
        height: unset;
      }

      &-block {
        grid-template-columns: repeat(2, 237px);
        column-gap: unset;
        width: 100%;
        justify-content: space-between;
      }
    }
  }
}

@media (max-width: 550px) {
  .better {
    &__main {
      &-block {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
</style>